/**
 * _shared.ts — Apoio comum às composições premium do Studio
 *
 * Reúne o que todas as famílias de modelos (capa, texto e imagem, recursos,
 * números, depoimentos, logos, galeria...) precisam: atalho para montar nós,
 * lista de saídas e o repertório de fotos do acervo compartilhado.
 *
 * As fotos NUNCA entram como endereço solto: entram como referência
 * `acervo://<chave>`, resolvida no desenho (web) e na publicação (HTML).
 *
 * RELEASE: v1.0.0 - 2026-09-10 - Versão inicial (Studio, motor de modelos — Lote A)
 */

import type { StudioPatternNode } from './types';
import type { StudioOutput } from '../types';

/** Atalho para montar um nó de padrão. */
export function b(
  type: string,
  props: Record<string, unknown> = {},
  children?: StudioPatternNode[],
): StudioPatternNode {
  return children ? { type, props, children } : { type, props };
}

/** Composições de página são desenhadas no navegador. */
export const WEB: StudioOutput[] = ['web'];

/**
 * Repertório de fotos do acervo compartilhado.
 * Trocar a foto no painel WL vale para todos os modelos de uma vez.
 */
export const FOTO = {
  cidadeNoite: 'acervo://capa.cidade-noite',
  reuniao: 'acervo://capa.reuniao',
  equipe: 'acervo://capa.equipe',
  escritorio: 'acervo://capa.escritorio',
  notebook: 'acervo://capa.notebook',
  painel: 'acervo://capa.painel',
  mesaTrabalho: 'acervo://capa.mesa-trabalho',
  atendimento: 'acervo://capa.atendimento',
  arquitetura: 'acervo://capa.arquitetura',
  palestra: 'acervo://capa.palestra',
  produto: 'acervo://capa.produto',
  loja: 'acervo://capa.loja',
  celular: 'acervo://capa.celular',
  criativo: 'acervo://capa.criativo',
  industria: 'acervo://capa.industria',
  consultoria: 'acervo://capa.consultoria',
  dados: 'acervo://capa.dados',
  interior: 'acervo://capa.interior',
  time: 'acervo://capa.time',
  laptopCodigo: 'acervo://capa.laptop-codigo',
  retrato: 'acervo://capa.retrato',
  minimal: 'acervo://capa.minimal',
  logistica: 'acervo://capa.logistica',
} as const;

/** Fotos pequenas usadas em prova social (avatares e depoimentos). */
export const AVATARES = [
  'acervo://capa.retrato|Cliente',
  'acervo://capa.equipe|Cliente',
  'acervo://capa.atendimento|Cliente',
].join('\n');
